
const defaultWorkShadowStatusFilter = ['Potential', 'Pipeline', 'Confirmed'];

export const defaultHSPInternProgressTrackerSearchParams = () => {
  return HspInternProgressTrackerSearchParamsModel.fromJS({
    advisorUsers: [],
    primaryOnly: true,
    hspOpportunityStatus: [],
    hspOpportunitySeasonNumber: undefined,
    hspOpportunitySeasonYear: undefined,
    statusFlags: defaultWorkShadowStatusFilter,
  })
}

export class HspInternProgressTrackerSearchParamsModel implements IHspInternProgressTrackerSearchParamsModel {
  advisorUsers?: string[] | undefined;
  primaryOnly?: boolean | undefined;
  hspOpportunityStatus?: string[] | undefined;
  hspOpportunitySeasonNumber?: number | undefined;
  hspOpportunitySeasonYear?: number | undefined;
  statusFlags?: string[] | undefined;

  constructor(data?: IHspInternProgressTrackerSearchParamsModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      if (Array.isArray(Data["advisorUsers"])) {
        this.advisorUsers = [] as any;
        for (let item of Data["advisorUsers"])
          this.advisorUsers!.push(item);
      }
      this.primaryOnly = Data["primaryOnly"];
      if (Array.isArray(Data["hspOpportunityStatus"])) {
        this.hspOpportunityStatus = [] as any;
        for (let item of Data["hspOpportunityStatus"])
          this.hspOpportunityStatus!.push(item);
      }
      this.hspOpportunitySeasonNumber = Data["hspOpportunitySeasonNumber"];
      this.hspOpportunitySeasonYear = Data["hspOpportunitySeasonYear"];
      if (Array.isArray(Data["statusFlags"])) {
        this.statusFlags = [] as any;
        for (let item of Data["statusFlags"])
          this.statusFlags!.push(item);
      }
    }
  }

  static fromJS(data: any): HspInternProgressTrackerSearchParamsModel {
    data = typeof data === 'object' ? data : {};
    let result = new HspInternProgressTrackerSearchParamsModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.advisorUsers)) {
      data["advisorUsers"] = [];
      for (let item of this.advisorUsers)
        data["advisorUsers"].push(item);
    }
    data["primaryOnly"] = this.primaryOnly;
    if (Array.isArray(this.hspOpportunityStatus)) {
      data["hspOpportunityStatus"] = [];
      for (let item of this.hspOpportunityStatus)
        data["hspOpportunityStatus"].push(item);
    }
    data["hspOpportunitySeasonNumber"] = this.hspOpportunitySeasonNumber;
    data["hspOpportunitySeasonYear"] = this.hspOpportunitySeasonYear;
    if (Array.isArray(this.statusFlags)) {
      data["statusFlags"] = [];
      for (let item of this.statusFlags)
        data["statusFlags"].push(item);
    }
    return data;
  }
}

export interface IHspInternProgressTrackerSearchParamsModel {
  advisorUsers?: string[] | undefined;
  primaryOnly?: boolean | undefined;
  hspOpportunityStatus?: string[] | undefined;
  hspOpportunitySeasonNumber?: number | undefined;
  hspOpportunitySeasonYear?: number | undefined;
  statusFlags?: string[] | undefined;
}